      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">X</span>
        </button>
        <storever-header-modal [title]="'SET_DEFAULT_MODAL_TITLE'" [icon]="'fal fa-star'"></storever-header-modal>
      </div>
      <storever-header-subtitle  [datas]="[{icon: 'fal fa-hdd', title: 'GENERIC_PLAYER_INFO', name: selectedPlayer?.deviceID}]"></storever-header-subtitle>
      <div class="modal-body">
        <div class="portlet-body">
            {{'SET_DEFAULT_PLAYER_CONFIRMATION_MESSAGE' | translate:locale.language}}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary"
                (click)="send()">
          <i class="fal fa-star"></i>
          {{'SET_DEFAULT_PLAYER_CONFIRMATION_BUTTON' | translate:locale.language}}
        </button>
        <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>
      </div>
